module.exports = __webpack_public_path__ + "img/banhji-logo-r.0ffdb63d.png";